export const convertCurrencyToNumber = (value = 0) => {
  return Number(value.replace(/[^\d]/g, ""));
};
